import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Target } from "lucide-react";
import { api } from "@/lib/api";

// Admin: attiva il bonus Big Match (risultato esatto) scegliendo una partita
// dalla griglia quote della stanza. Solo gloria (badge in classifica).
export default function BonusStanzaAdmin({ roomId, onChanged }) {
  const [open, setOpen] = useState(false);
  const [matches, setMatches] = useState([]);
  const [cfg, setCfg] = useState(null);
  const [sel, setSel] = useState("");
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try {
      const g = await api(`/rooms/${roomId}/grid`);
      setMatches(g.matches || []);
      const b = await api(`/rooms/${roomId}/bonus`);
      setCfg(b);
      if (b?.enabled && b.home) {
        const m = (g.matches || []).find((x) => x.home === b.home && x.away === b.away);
        if (m) setSel(m.match_id);
      }
    } catch (e) { /* nessuna griglia */ }
  }, [roomId]);
  useEffect(() => { if (open) load(); }, [open, load]);

  const save = async () => {
    if (!sel) { toast.error("Scegli una partita dalla griglia"); return; }
    setBusy(true);
    try {
      await api(`/rooms/${roomId}/bonus`, { method: "POST", body: { match_id: sel, enabled: true } });
      toast.success("Bonus Big Match attivato");
      await load(); onChanged?.();
    } catch (e) { toast.error(e.message); }
    finally { setBusy(false); }
  };
  const disable = async () => {
    setBusy(true);
    try {
      await api(`/rooms/${roomId}/bonus`, { method: "POST", body: { enabled: false } });
      toast.success("Bonus disattivato");
      setSel(""); await load(); onChanged?.();
    } catch (e) { toast.error(e.message); }
    finally { setBusy(false); }
  };

  if (!open) {
    return (
      <button data-testid="bonus-admin-open" onClick={() => setOpen(true)} className="w-full flex items-center justify-center gap-2 border border-[#10B981]/40 bg-[#10B981]/5 text-[#10B981] rounded-xl py-2.5 text-sm font-bold hover:bg-[#10B981]/10">
        <Target size={16} /> Bonus Big Match stanza (admin)
      </button>
    );
  }

  return (
    <div className="rounded-xl border border-[#10B981]/40 bg-[#181D22] p-4 space-y-3" data-testid="bonus-admin-panel">
      <div className="flex items-center justify-between">
        <div className="font-extrabold flex items-center gap-2"><Target size={16} className="text-[#10B981]" /> Bonus Big Match (risultato esatto)</div>
        <button onClick={() => setOpen(false)} className="text-xs text-[#94A3B8] hover:text-white">Chiudi</button>
      </div>
      {cfg?.enabled && <div className="text-xs text-[#10B981]">Attivo: <b>{cfg.home} - {cfg.away}</b>. I giocatori pronosticano il risultato esatto dalla sezione Bonus. Solo gloria.</div>}
      {matches.length === 0 ? (
        <p className="text-xs text-[#94A3B8]">Imposta prima la griglia quote: il bonus si sceglie tra le partite della griglia.</p>
      ) : (
        <>
          <select data-testid="bonus-admin-select" value={sel} onChange={(e) => setSel(e.target.value)} className="w-full bg-[#0F1216] border border-white/15 rounded-md px-3 py-2 text-sm text-white">
            <option value="">— scegli la partita del bonus —</option>
            {matches.map((m) => <option key={m.match_id} value={m.match_id}>{m.home} - {m.away}</option>)}
          </select>
          <div className="flex gap-2">
            <button data-testid="bonus-admin-save" onClick={save} disabled={busy} className="flex-1 bg-[#10B981] text-[#04130D] font-bold rounded-md py-2 text-sm disabled:opacity-50">{busy ? "..." : "Attiva bonus"}</button>
            {cfg?.enabled && <button data-testid="bonus-admin-disable" onClick={disable} disabled={busy} className="border border-[#EF4444]/40 text-[#EF4444] rounded-md px-3 py-2 text-sm font-bold">Disattiva</button>}
          </div>
        </>
      )}
    </div>
  );
}
